// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pWrx","controls":"styles_controls__3ROMv","charLimit":"styles_charLimit__3wSB_","input":"styles_input__3qyko","send":"styles_send__1OqP_"};